/**
 * クライアントごとの設定
 */
let clientSettings
let targetDomain

try {
  targetDomain = window.location.hostname
  clientSettings = require(`clientSettings/${targetDomain}/clientSettings.json`)
} catch (e) {
  const domains = window.location.hostname.split('.')
  //サブドメインに-stgがついている場合、-stgを省いたもののクライアント設定を読み込む
  if (domains[0].slice(-4) === '-stg') {
    domains[0] = domains[0].slice(0, -4)
    try {
      targetDomain = domains.join('.')
      clientSettings = require(`clientSettings/${targetDomain}/clientSettings.json`)
    } catch (e) {
      targetDomain = 'template'
      clientSettings = require(`clientSettings/${targetDomain}/clientSettings.json`)
    }
  } else {
    if (window.location.hostname.endsWith('.localhost')) {
      try {
        // ローカルテスト用設定の読み込み
        targetDomain = window.location.hostname.substring(
          0,
          window.location.hostname.length - 10
        )
        clientSettings = require(`clientSettings/${targetDomain}/clientSettings.json`)
      } catch (e) {
        targetDomain = 'template'
        clientSettings = require(`clientSettings/${targetDomain}/clientSettings.json`)
      }
    } else {
      targetDomain = 'template'
      clientSettings = require(`clientSettings/${targetDomain}/clientSettings.json`)
    }
  }
}

// 読み込んでいるクライアント設定のドメインを確保
clientSettings.targetDomain = targetDomain

// 枠線のカラーコードを確保
clientSettings.colors.borderColor = clientSettings.colors.border

// 枠線は薄くして使う
clientSettings.colors.border = `${clientSettings.colors.border}30`

export const CLIENT_SETTINGS = clientSettings
